import storage from '../services/storage';

export default {
    data: {},
    locale: storage.get('locale', true),

    t(key) {
        if (!Object.keys(this.data).length) {
            return key;
        }

        return this.getTranslation(key);
    },

    setTranslations(translations) {
        this.data = translations;
    },

    getTranslation(key) {
        if (this.data.hasOwnProperty(key)) {
            return this.data[key][this.locale];
        }

        return key;
    }
};